/**
 *
 * Text
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import styles from './style.css';

function Text({ type, text, selectable = true, className, ...rest }) {
  const customStyles = [];
  if (className)
    className.split(' ').forEach(classNameArg => {
      customStyles.push(styles[classNameArg]);
    });

  return (
    <span
      className={`${styles[type] ? styles[type] : ''} ${
        selectable ? '' : styles.noSelect
      } ${customStyles.join(' ').toString()}`}
      {...rest}
    >
      {text}
    </span>
  );
}

Text.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  bold: PropTypes.string,
  selectable: PropTypes.bool,
  className: PropTypes.string,
};

export default Text;
